import '../scss/error-message.scss';

const ErrorMessage = () => {
  return (
    <div className="error-message">
      <p className="error-message__title">Učitavanje nije uspelo</p>
      <p className="error-message__body">
        Proverite internet konekciju i pokušajte ponovo. Ako problem opstaje,
        servis je možda privremeno nedostupan.
      </p>
      <button
        className="button error-message__reload"
        onClick={() => window.location.reload()}
      >
        Osveži stranicu
      </button>
    </div>
  );
};

export default ErrorMessage;
